$(document).ready(function () {
  if(!isEmpty($('#coll-view'))) { 
    console.log(localStorage.getItem('type'));
    if(localStorage.getItem('type') == null ) {
      var type = $('#category-view-type').val();
      var cols = $('#category-grid-cols').val();

      if(type == "list") {
        category_view.initView(type, cols, 'btn-list');
        category_view.customList();
      }

      if(type == 'grid') {
        console.log(type + cols);
        category_view.initView(type, cols, 'btn-grid-' + cols);
        category_view.customGrid();
      }
    } else {
      var type = localStorage.getItem('type');
      var cols = localStorage.getItem('cols'); //Not taking from cache because one column count allowed at a time
      //var cols = $('#category-grid-cols').val();
      var element = localStorage.getItem('element');
      category_view.initView(type, cols, element);
    }
  } else {
    localStorage.setItem('type', null);
  }
});
/*
$(document).ready(function () {
  if(localStorage.getItem('type') == null) {
    var type = $('#category-view-type').val();
    var cols = $('#category-grid-cols').val();

    if(type == "list") {
      category_view.initView(type, cols, 'btn-list');
      category_view.customList();
    }

    if(type == 'grid') {
      category_view.initView(type, cols, 'btn-grid-' + cols);
      category_view.customGrid();
    }
  } else {
    var type = localStorage.getItem('type');
    var cols = localStorage.getItem('cols');
    var element = localStorage.getItem('element');

    category_view.initView(type, cols, element);
  }
});
*/
var category_view = {
  'initView' : function (type, cols, element) {
    category_view.changeView(type, cols, element);
  },

  'changeView' : function (type, cols, element) {
    if(type == "grid") {
      var column = parseInt(cols);
      if(column == 2) {
        $('#custom-products .product-item').attr('class', 'col-lg-6 col-md-6 col-sm-6 col-6 product-item');
        $('#custom-products .product-item > div:first-child').attr('class', 'carparts_product_grid');
      }
      if(column == 3) {
        $('#custom-products .product-item').attr('class', 'col-lg-4 col-md-4 col-sm-6 col-6 product-item');
        $('#custom-products .product-item > div:first-child').attr('class', 'carparts_product_grid');
      }
      if(column == 4) {
        $('#custom-products .product-item').attr('class', 'col-lg-3 col-md-4 col-sm-6 col-6 product-item');
        $('#custom-products .product-item > div:first-child').attr('class', 'carparts_product_grid');
      }

      category_view.customGrid();
    }

    if(type == "list") {
      $('#custom-products .product-item').attr('class', 'col-6 product-item');
      $('#custom-products .product-item > div:first-child').attr('class', 'carparts_product_listlayout');
      category_view.customList();
    }

    $('.btn-custom-view').removeClass('active');
    $('.' + element).addClass('active');

    localStorage.setItem('type', type);
    localStorage.setItem('cols', cols);
    localStorage.setItem('element', element);
    
    //console.log(grid_auto_resize);

  },

  'customList' : function() {
    $(".product-item").each(function() {
      var images_container = $(this).find('.item_image');
      $(this).find('.product_label').appendTo(images_container);

      //$( ".product-item .item_content" ).add( "div" ).addClass( "action_btns_wrap" );
      var content_container = $(this).find('.item_content');
      var action_btns_wrap = $(this).find('.action_btns_wrap');
      $(this).find('.price_text').appendTo(action_btns_wrap);
      //action_btns_wrap += "+$(this).find('.price_text')+";
      $(this).find('.product_action_btns').removeClass('ul_li_center').addClass('ul_li');
      $(this).find('.product_action_btns').appendTo(action_btns_wrap);
      //action_btns_wrap += $(this).find('.product_action_btns');
      //action_btns_wrap += '</div>';
      //$(this).find('.item_content').append(action_btns_wrap);

    });
  },

  'customGrid' : function() {
    $(".product-item").each(function() {
      var images_container = $(this).find('.item_image');
      $(this).find('.product_action_btns').removeClass('ul_li').addClass('ul_li_center');
      $(this).find('.product_action_btns').appendTo(images_container);
      var content_container = $(this).find('.item_content');
      $(this).find('.price_text').appendTo(content_container);
      $(this).find('.product_label').appendTo(content_container);
    });
  }
}